var map = {
	"./info-sharing-accounts-de.html": 1012,
	"./info-sharing-accounts-en.html": 1013,
	"./info-sharing-accounts-es.html": 1014,
	"./info-sharing-accounts-fr.html": 1015,
	"./info-sharing-accounts-ja.html": 1016,
	"./info-sharing-accounts-pt.html": 1017,
	"./info-sharing-accounts-zh.html": 1018
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1011;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts ^\.\/info\-sharing\-accounts\-.*\.html$
// module id = 1011
// module chunks = 0